'use strict';

var Utils = require('../../utils/utils');

var Clone = function(config) {

  var self = this;
  var $header = $(config.header);
  var $target = $(config.cloneTarget);

  self.getBreakpointName = function() {
    var breakpointName = $target.attr('data-clone-entry-header-up-to').toUpperCase();
    self.viewportHandler(breakpointName);
  }

  self.viewportHandler = function(breakpointName) {

    var largeViewports = function() {
      self.destroy();
    };

    var smallViewports = function() {
      self.cloneHeader();
    };

    new Utils().matchmediaHandler(breakpointName, largeViewports, smallViewports);
  }

  self.cloneHeader = function() {

    var $originalHeader = $header.not('.is-clone');

    if ($target.children().length === 0) {
      var $clone = $header.clone().addClass('is-clone');
      $target.append($clone);
    }

    self.cloneVisibility($originalHeader);
  }

  self.cloneVisibility = function($originalHeader) {
    $target.show();
    $originalHeader.hide();
  }

  self.destroy = function() {
    $target.hide();
    $header.show();
  }

  self.init = function() {

    if ($target.length) {
      self.getBreakpointName();
    }
  }
};

module.exports = Clone;
